import Request from './request'
import consts from '@/consts.js'

async function fetch (data) {
  return Request('get', 'api/delivery-points', data)
}

async function fetchOne (id) {
  // 获取单个
  return Request('get', 'api/delivery-points/view/' + id)
}

async function fetchAll (data) {
// 获取全部
  if (!data) {
    data = {}
  }
  data.limit = consts.limitAll //获取全部
  return Request('get', 'api/delivery-points', data)
}

async function save (id, data) {
  // 编辑或新建数据（有id为编辑，没有id为新建）
  if (id) {
    return Request('post', 'api/delivery-points/edit?id=' + id, data)
  } else {
    return Request('post', 'api/delivery-points/add', data)
  }
}

async function del (id) {// 删除数据
  return Request('delete', "api/delivery-points/delete/" + id);
}

async function getDistrictShops(data) {
  return Request('get', 'api/delivery-points/get-district-shops', data)
}

async function bind(data) {
  return Request('post', 'api/delivery-points/bind', data)
}

async function unbind(data) {
  return Request('post', 'api/delivery-points/un-bind', data)
}

async function getRelations(data) {
  return Request('get', 'api/delivery-points/relations', data)
}



export default {
  fetch,
  fetchOne,
  fetchAll,
  save,
  del,
  getDistrictShops,
  bind,
  unbind,
  getRelations,
}
